import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { AnimatedCheckComponent } from '../../snippets/animated-check/animated-check.component';
import { ToastsService } from '@catch/services';
import { TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { ReminderChannel } from '../../../enums/reminder-channel.enum';
import { SEOService } from '../../../services/seo.service';

@UntilDestroy()
@Component({
  selector: 'app-unsubscribe-mail',
  templateUrl: './unsubscribe-mail.component.html',
  styleUrls: ['./unsubscribe-mail.component.scss'],
  imports: [FormsModule, TranslocoPipe, AnimatedCheckComponent],
})
export class UnsubscribeMailComponent implements OnInit {
  private readonly jobboardAdapter = inject(JobboardAdapter);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly seoService = inject(SEOService);
  private readonly toastsService = inject(ToastsService);
  private readonly translateService = inject(TranslocoService);

  success: boolean = false;
  reminderChannels: {
    channel: ReminderChannel;
    name: string;
    unsubscribe: boolean;
  }[] = [
    {
      channel: ReminderChannel.EMAIL,
      name: 'jobboard.views.unsubscribe.reminder-channels.email',
      unsubscribe: false,
    },
    {
      channel: ReminderChannel.WHATSAPP,
      name: 'jobboard.views.unsubscribe.reminder-channels.whatsapp',
      unsubscribe: false,
    },
  ];

  ngOnInit(): void {
    if (
      !this.route.snapshot.params['applicationId'] ||
      !this.route.snapshot.queryParams['nonce']
    ) {
      this.toastsService.alert('ct-library.errors.auth.invalid-link');
      this.router.navigate(['/']);
    }
    this.seoService.updateTitle(
      this.translateService.translate('jobboard.views.unsubscribe.title')
    );
    this.seoService.updateDescription('');
    this.jobboardAdapter
      .getReminderChannels(
        this.route.snapshot.params['applicationId'],
        this.route.snapshot.queryParams['nonce']
      )
      .pipe(untilDestroyed(this))
      .subscribe((channels: { channel: number; on: boolean }[]) => {
        this.reminderChannels.forEach((channel) => {
          const reminderChannel = channels.find(
            (c) => c.channel === channel.channel
          );
          if (reminderChannel) {
            channel.unsubscribe = !reminderChannel.on;
          }
        });
      });
  }

  hasSelectedChannel(): boolean {
    return !!this.reminderChannels.find((channel) => channel.unsubscribe);
  }

  submitUnsubscribeForm() {
    if (!this.reminderChannels.find((channel) => !channel.unsubscribe)) {
      this.jobboardAdapter
        .unsubscribeReminder(
          this.route.snapshot.params['applicationId'],
          this.route.snapshot.queryParams['nonce']
        )
        .pipe(untilDestroyed(this))
        .subscribe(() => (this.success = true));
    } else {
      this.jobboardAdapter
        .updateReminderChannels(
          this.route.snapshot.params['applicationId'],
          this.route.snapshot.queryParams['nonce'],
          this.reminderChannels
            .filter((channel) => channel.unsubscribe)
            .map((channel) => channel.channel)
        )
        .pipe(untilDestroyed(this))
        .subscribe(() => (this.success = true));
    }
  }
}
